//@ts-check

import { FEATURES } from './common';

const RoutesRouterConfig = ($stateProvider, $urlRouterProvider) => {
	const _turnOffIsLoggingIn = ($rootScope) => {
		'ngInject';
		const payLoad = {
			err: null,
			isBusy: false
		};

		$rootScope.$broadcast('change-is-busy', false);

		$rootScope.$broadcast('user-login-busy', payLoad);
	};

	const registerRoutes = () => {
		registerProfileRout();
		registerTenantRoute();
		registerLevyRollRoute();
		registerRegisterRoute();
		registerPaymentsRoute();
		registerDashboardRoute();
		registerDocumentsRoute();
		registerComplianceRoute();
		registerBalanceSheetRoute();
		registerAccountsHistoryRoute();
		registerIncomeStatementRoute();
		registerContractorsRollRoute();
		registerFinancialSummaryRoute();
		registerClearanceCaptureRoute();
		registerClearanceRequestRoute();
		registerCashflowStatementRoute();
		registerCashflowStatementNewRoute();
		registerPersonalDocumentsRoute();
		registerPaymentAuthorisationRoute();
		registerUtilityRoute();
		registerDocumentsApprovalRoute();
		registerLoginRoute();
		registerSetPasswordRoute();
		registerHistoricalLinkRoute();
		registerRentalsCaptureRoute();
        registerAuditsCaptureRoute();
		registerAuditorsDashboardRoute();
        registerWagesRollRoute();
		registerTrusteeRoute();
		registerIncomeVSBudgetRoute();
		registerDebtorAgeAnalysisRoute();
		registerFindAContractorRoute();
		$urlRouterProvider.otherwise(`/${FEATURES.LOGIN}`); //red become the default view
	};

	const registerHistoricalLinkRoute = () => {
		const historicallink = {
			controller: 'HistoricalLinkCtrl',
			controllerAs: 'HistoricalLinkVM',
			name: FEATURES.HISTORICAL_LINK,
			url: `/${FEATURES.HISTORICAL_LINK}`,
			templateUrl: 'accounts/historical-link/historical-link.html'
		};

		$stateProvider.state(historicallink);
	};
	const registerLoginRoute = () => {
		const login = {
			controller: 'LoginCtrl',
			controllerAs: 'LoginVM',
			name: FEATURES.LOGIN,
			url: `/${FEATURES.LOGIN}`,
			templateUrl: 'accounts/login/login.html'
		};

		$stateProvider.state(login);
	};

	const registerSetPasswordRoute = () => {
		const setPassword = {
			controller: 'SetPasswordCtrl',
			controllerAs: 'SetPasswordVM',
			name: FEATURES.SET_PASSWORD,
			url: `/${FEATURES.SET_PASSWORD}`,
			templateUrl: 'accounts/set-password/set-password.html'
		};

		$stateProvider.state(setPassword);
	};
	const registerProfileRout = () => {
		const profile = {
			controller: 'ProfileCtrl',
			controllerAs: 'ProfileVM',
			name: FEATURES.MY_PROFILE,
			url: `/${FEATURES.MY_PROFILE}`,
			templateUrl: 'accounts/profile/profile.html'
		};

		$stateProvider.state(profile);
	};
	const registerUtilityRoute = () => {
		const utilityRoute = {
			controller: 'UtilityinfoCtrl',
			controllerAs: 'UtilityinfoVM',
			name: FEATURES.UTILITY,
			url: `/${FEATURES.UTILITY}`,
			templateUrl: 'utility-info/utility-info.html'
		};

		$stateProvider.state(utilityRoute);
	};

    const registerDocumentsApprovalRoute = () => {
		const viewDocsApprovalRoute = {
			controller: 'DocumentsApprovalCtrl',
			controllerAs: 'DocumentsApprovalVM',
			name: FEATURES.DOCUMENTS_APPROVAL,
			url: `/${FEATURES.DOCUMENTS_APPROVAL}`,
			templateUrl: 'approval-documents/documents-approval.html'
		};

		$stateProvider.state(viewDocsApprovalRoute);
	};

	const registerTenantRoute = () => {
		const tenantRoute = {
			name: FEATURES.TENANT,
			controller: 'TenantCtrl',
			controllerAs: 'TenantVM',
			url: `/${FEATURES.TENANT}`,
			templateUrl: 'accounts/tenant/tenant.html'
		};

		$stateProvider.state(tenantRoute);
	};

	const registerRegisterRoute = () => {
		const registerRoute = {
			name: FEATURES.REGISTER,
			controller: 'RegisterCtrl',
			controllerAs: 'RegisterVM',
			resolve: {
				unused: _turnOffIsLoggingIn
			},
			url: `/${FEATURES.REGISTER}?email&token`,
			templateUrl: 'accounts/register/register.html'
		};

		$stateProvider.state(registerRoute);
	};

	const registerPaymentsRoute = () => {
		const paymentsRoute = {
			name: FEATURES.PAYMENTS,
			controller: 'PaymentCtrl',
			controllerAs: 'paymentApprovalVm',
			url: `/${FEATURES.PAYMENTS}?dbRef&paymentId&tab`,
			params: {
				paymentId: { value: null, dynamic: true },
				tab: { value: null, dynamic: true }
			},
			templateUrl: 'payments/payments.html'
		};

		$stateProvider.state(paymentsRoute);
	};

	const registerLevyRollRoute = () => {
		const levyRollRoute = {
			name: FEATURES.LEVY_ROLL,
			controller: 'LevyRollCtrl',
			controllerAs: 'levyRollVm',
			url: `/${FEATURES.LEVY_ROLL}?date`,
			templateUrl: 'financials/levy-roll/levy-roll.html'
		};

		$stateProvider.state(levyRollRoute);
	};

	const registerDashboardRoute = () => {
		const dashboardRoute = {
			url: '/',
			name: FEATURES.DASHBOARD,
			controller: 'DashboardCtrl',
			controllerAs: 'DashboardVM',
			templateUrl: 'dashboard/dashboard.html'
		};

		$stateProvider.state(dashboardRoute);
	};

	const registerDocumentsRoute = () => {
		const documentsRoute = {
			name: FEATURES.DOCUMENTS,
			controllerAs: 'documentsVm',
			url: `/${FEATURES.DOCUMENTS}?nav`,
			controller: 'BuildingDocumentsCtrl',
			templateUrl: 'building-documents/building-documents.html',
			params: { isItFinancialsSection: false }
		};

		$stateProvider.state(documentsRoute);
	};

	const registerComplianceRoute = () => {
		const complianceRoute = {
			name: FEATURES.COMPLIANCE,
			controllerAs: 'ComplianceVM',
			controller: 'ComplianceCtrl',
			url: `/${FEATURES.COMPLIANCE}`,
			templateUrl: 'compliance/compliance.html'
		};

		const fireCompliance = {
			url: '/fire',
			name: 'compliance.fire',
			templateUrl: 'compliance/views/fire-compliance.html'
		};

		const miniSubCompliance = {
			url: '/mini-sub',
			name: 'compliance.mini-sub',
			templateUrl: 'compliance/views/mini-sub-compliance.html'
		};

		const liftCompliance = {
			url: '/lift',
			name: 'compliance.lift',
			templateUrl: 'compliance/views/lift-compliance.html'
		};

		$stateProvider.state(complianceRoute);
		$stateProvider.state(fireCompliance);
		$stateProvider.state(miniSubCompliance);
		$stateProvider.state(liftCompliance);
	};

	const registerBalanceSheetRoute = () => {
		const balanceSheetRoute = {
			name: FEATURES.BALANCE_SHEET,
			controller: 'BalanceSheetCtrl',
			controllerAs: 'balanceSheetVm',
			url: `/${FEATURES.BALANCE_SHEET}?date`,
			templateUrl: 'financials/balance-sheet/balance-sheet.html'
		};

		$stateProvider.state(balanceSheetRoute);
	};

	const registerAccountsHistoryRoute = () => {
		const accountsHistoryRoute = {
			name: FEATURES.ACCOUNT_HISTORY,
			controller: 'AccountsHistoryCtrl',
			controllerAs: 'accountsHistoryVm',
			url: `/${FEATURES.ACCOUNT_HISTORY}?cardCode`,
			templateUrl: 'accounts/accounts-history/accounts-history.html'
		};

		$stateProvider.state(accountsHistoryRoute);
	};

	const registerContractorsRollRoute = () => {
		const contractorsRollRoute = {
			name: FEATURES.CONTRACTORS_ROLL,
			controller: 'ContractorsRollCtrl',
			controllerAs: 'contractorsRollVm',
			url: `/${FEATURES.CONTRACTORS_ROLL}?date`,
			templateUrl: 'financials/contractors-roll/contractors-roll.html'
		};

		$stateProvider.state(contractorsRollRoute);
	};

	const registerClearanceCaptureRoute = () => {
		const clearanceCaptureRoute = {
			name: FEATURES.CLEARANCE_CAPTURE,
			controllerAs: 'clearanceCaptureVm',
			controller: 'ClearanceCaptureCtrl',
			url: `/${FEATURES.CLEARANCE_CAPTURE}`,
			templateUrl: 'clearances/clearance-capture.html',
			resolve: {
				unused: _turnOffIsLoggingIn
			}
		};

		$stateProvider.state(clearanceCaptureRoute);
	};

	const registerClearanceRequestRoute = () => {
		const clearanceRequestRoute = {
			name: FEATURES.CLEARANCE_REQUEST,
			controllerAs: 'clearanceRequestVm',
			controller: 'ClearanceRequestCtrl',
			url: `/${FEATURES.CLEARANCE_REQUEST}`,
			templateUrl: 'clearances/clearance-request/clearance-request.html',
			resolve: {
				unused: _turnOffIsLoggingIn
			}
		};

		$stateProvider.state(clearanceRequestRoute);
	};

	const registerFinancialSummaryRoute = () => {
		const financialSummaryRoute = {
			name: FEATURES.FINANCIAL_SUMMARY,
			controller: 'FinancialSummaryCtrl',
			controllerAs: 'financialSummaryVm',
			url: `/${FEATURES.FINANCIAL_SUMMARY}?date`,
			templateUrl: 'financials/financial-summary/financial-summary.html'
		};

		$stateProvider.state(financialSummaryRoute);
	};

	const registerIncomeStatementRoute = () => {
		const incomeStatementRoute = {
			name: FEATURES.INCOME_STATEMENT,
			controller: 'IncomeStatementCtrl',
			controllerAs: 'incomeStatementVm',
			url: `/${FEATURES.INCOME_STATEMENT}?date`,
			templateUrl: 'financials/income-statement/income-statement.html'
		};

		$stateProvider.state(incomeStatementRoute);
	};

	const registerPersonalDocumentsRoute = () => {
		const personalDocumentsRoute = {
			name: FEATURES.PERSONAL_DOCUMENTS,
			controller: 'PersonalDocumentsCtrl',
			controllerAs: 'personalDocumentsVm',
			url: `/${FEATURES.PERSONAL_DOCUMENTS}?cardCode&folder`,
			templateUrl: 'personal-documents/personal-documents.html'
		};

		$stateProvider.state(personalDocumentsRoute);
	};

	const registerCashflowStatementRoute = () => {
		const cashflowStatementRoute = {
			name: FEATURES.CASHFLOW_STATEMENT,
			controller: 'CashflowStatementCtrl',
			controllerAs: 'cashflowStatementVm',
			url: `/${FEATURES.CASHFLOW_STATEMENT}?date`,
			templateUrl: 'financials/cashflow-statement/cashflow-statement.html'
		};

		$stateProvider.state(cashflowStatementRoute);
	};

	const registerCashflowStatementNewRoute = () => {
		const cashflowStatementNewRoute = {
			name: FEATURES.CASHFLOW_STATEMENT_NEW,
			controller: 'CashflowStatementNewCtrl',
			controllerAs: 'cashflowStatementNewVm',
			url: `/${FEATURES.CASHFLOW_STATEMENT_NEW}?date`,
			templateUrl: 'financials/cashflow-statement-new/cashflow-statement-new.html'
		};

		$stateProvider.state(cashflowStatementNewRoute);
	};

	const registerPaymentAuthorisationRoute = () => {
		const paymentAuthorisationRoute = {
			name: FEATURES.PAYMENT_AUTHORISATION,
			controller: 'PaymentAuthorisationCtrl',
			controllerAs: 'paymentAuthorisationVm',
			url: `/${FEATURES.PAYMENT_AUTHORISATION}?DBRef`,
			templateUrl: 'payment-authorisation/payment-authorisation.html'
		};

		$stateProvider.state(paymentAuthorisationRoute);
	};

	const registerRentalsCaptureRoute = () => {
		const rentalsCaptureRoute = {
			name: FEATURES.RENTALS_CAPTURE,
			controllerAs: 'rentalsCaptureVm',
			controller: 'RentalsCaptureCtrl',
			url: `/${FEATURES.RENTALS_CAPTURE}`,
			templateUrl: 'rentals/rentals-capture.html',
			resolve: {
				unused: _turnOffIsLoggingIn
			}
		};

		$stateProvider.state(rentalsCaptureRoute);
	};

	const registerAuditsCaptureRoute = () => {
		const auditsCaptureRoute = {
			name: FEATURES.AUDITS_CAPTURE,
			controllerAs: 'auditsCaptureVm',
			controller: 'AuditsCaptureCtrl',
			url: `/${FEATURES.AUDITS_CAPTURE}`,
			templateUrl: 'audits/audits-capture.html',
			resolve: {
				unused: _turnOffIsLoggingIn
			}
		};

		$stateProvider.state(auditsCaptureRoute);
    };

	const registerAuditorsDashboardRoute = () => {
		const auditorsDashboardRoute = {
			name: FEATURES.AUDITORS_DASHBOARD,
			controllerAs: 'auditorsDashboardVm',
			controller: 'AuditorsDashboardCtrl',
			url: `/${FEATURES.AUDITORS_DASHBOARD}`,
			templateUrl: 'auditors-dashboard/auditors-dashboard.html',
			resolve: {
				unused: _turnOffIsLoggingIn
			}
		};

		$stateProvider.state(auditorsDashboardRoute);
    };

    const registerWagesRollRoute = () => {
        const wagesRollRoute = {
            name: FEATURES.WAGES_ROLL,
            controller: 'WagesRollCtrl',
            controllerAs: 'wagesRollVm',
            url: `/${FEATURES.WAGES_ROLL}?date`,
            templateUrl: 'financials/wages-roll/wages-roll.html'
        };

        $stateProvider.state(wagesRollRoute);
	};

	const registerTrusteeRoute = () => {
		const trusteeRoute = {
			controller: 'TrusteeDashboardCtrl',
			controllerAs: 'TrusteeDashboardVM',
			name: FEATURES.TRUSTEE_DASHBOARD,
			url: `/${FEATURES.TRUSTEE_DASHBOARD}`,
			templateUrl: 'trustee-dashboard/trustee-dashboard.html'
		};

		$stateProvider.state(trusteeRoute);
	};

	const registerIncomeVSBudgetRoute = () => {
		const incomeVsBudgetRoute = {
			controller: 'IncomeVSBudgetCtrl',
			controllerAs: 'incomeVSBudgetVm',
			name: FEATURES.INCOME_VS_BUDGET,
			url: `/${FEATURES.INCOME_VS_BUDGET}`,
			templateUrl: 'financials/income-vs-budget/income-vs-budget.html'
		};

		$stateProvider.state(incomeVsBudgetRoute);
	};

	const registerDebtorAgeAnalysisRoute = () => {
		const debtorAgeAnalysisRoute = {
			controller: 'DebtorAgeAnalysisCtrl',
			controllerAs: 'debtorAgeAnalysisVm',
			name: FEATURES.DEBTOR_AGE_ANALYSIS,
			url: `/${FEATURES.DEBTOR_AGE_ANALYSIS}`,
			templateUrl: 'financials/debtor-age-analysis/debtor-age-analysis.html'
		};

		$stateProvider.state(debtorAgeAnalysisRoute);
	};

	const registerFindAContractorRoute = () => {
		const contractorRoute = {
			controller: 'FindAContractorCtrl',
			controllerAs: 'findAContractorVm',
			name: FEATURES.SHOW_FIND_A_CONTRACTOR,
			url: `/${FEATURES.SHOW_FIND_A_CONTRACTOR}`,
			templateUrl: 'contractors/find-a-contractor.html'
		};

		$stateProvider.state(contractorRoute);
	};

	registerRoutes();
};

export default RoutesRouterConfig;
